import { useTranslation } from 'react-i18next';

const Awards = () => {
    const { t } = useTranslation();
    return (
        <div className="mb-6 mb-md-80">
            <h2 className="text-center">{t("Premios y reconocimientos")}</h2>
            <ul className="mb-6 o-list-features row">
                <li className="col-12 col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <figure className="mb-0 mb-sm-5">
                        <img src="https://pro-static.h10hotels.com/gallery/Biosphere_Sustainable.png" alt="Biosphere Sustainable" />
                    </figure>
                    <span className="text-xxs text-uppercase">
                        <strong>Biosphere Tourism</strong>
                        <br /> Biosphere Sustainable <br /> 2025 </span>
                </li>
                <li className="col-12 col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <figure className="mb-0 mb-sm-5">
                        <img src="https://pro-static.h10hotels.com/gallery/H10Quality.png" alt="H10 Quality Excellence Management System" />
                    </figure>
                    <span className="text-xxs text-uppercase">
                        <strong>H10 Hotels</strong>
                        <br /> H10 Quality Excellence Management System <br /> 2024 </span>
                </li>
                <li className="col-12 col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <figure className="mb-0 mb-sm-5">
                        <img src="https://pro-static.h10hotels.com/gallery/ISO2015_TuvRheinland.png" alt="ISO 9001:2015" />
                    </figure>
                    <span className="text-xxs text-uppercase">
                        <strong>TÜV Rheinland</strong>
                        <br /> ISO 9001:2015 <br /> 2025 </span>
                </li>
                <li className="col-12 col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <figure className="mb-0 mb-sm-5">
                        <img src="https://pro-static.h10hotels.com/gallery/Tripadvisor_Top10Cadenas.png" alt="Tripadvisor - Top 10 de las cadenas hoteleras “más excelentes” del mundo" />
                    </figure>
                    <span className="text-xxs text-uppercase">
                        <strong>Tripadvisor</strong>
                        <br /> Top 10 de las cadenas hoteleras “más excelentes” del mundo <br /> 2018 </span>
                </li>
                <li className="col-12 col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <figure className="mb-0 mb-sm-5">
                        <img src="https://pro-static.h10hotels.com/gallery/Tripadvisor_TravellersChoice.png" alt="Tripadvisor - Travellers' Choice" />
                    </figure>
                    <span className="text-xxs text-uppercase">
                        <strong>Tripadvisor</strong>
                        <br /> Travellers' Choice <br /> 2023, 2020 </span>
                </li>
                <li className="col-12 col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <figure className="mb-0 mb-sm-5">
                        <img src="https://pro-static.h10hotels.com/gallery/Tripadvisor_CertificadoDeExcelencia.png" alt="Tripadvisor - Certificado de Excelencia" />
                    </figure>
                    <span className="text-xxs text-uppercase">
                        <strong>Tripadvisor</strong>
                        <br /> Certificado de Excelencia <br /> 2019, 2018, 2017, 2015 </span>
                </li>

            </ul>
            <div className="d-flex justify-content-center">
                <button type="button" className="btn btn-secondary">{t("Ver todos los premios y reconocimientos")}</button>
            </div>
        </div>
    );
};

export default Awards;
